/**
 * ユーザーIDを保持するVO
 *
 */
export class UserIDModel {
  /**
   * ユーザーID
   */
  public associatedUserId: string = <string>'';
}
